export interface TextFieldProps {
  onClick?: any;
  onChange?: any;
  type?: InpitTypes;
  field: FieldsTypes;
  placeholder?: string;
  className?: string;
  validation?: boolean;
  validRegister?: any;
  autoComplete?: "off";
  color?: "primary";
  disabled?: boolean;
  date?: boolean;
  dateValue?: string | Date;
  setDateValue?: any;
  subscribe?: boolean;
}

export enum FieldsTypes {
  input = "input",
  textarea = "textarea",
}
export enum InpitTypes {
  email = "email",
  number = "number",
  text = "text",
  date = "date",
}
